import { Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { OktaService } from '../../shared/services/okta.service';
import { SidenavLink } from '@healthcatalyst/cashmere';

/** Admin container  */
@Component({
    selector: 'pd-admin-portal',
    templateUrl: './admin-portal.component.html',
    styleUrls: ['./admin-portal.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AdminPortalComponent implements OnDestroy {
    private unsubscribe = new Subject<void>();
    isEditing = false;
    tabs: SidenavLink[] = [
        new SidenavLink({ title: 'Suites', iconClass: 'hc-icons hci-model', description: 'Edit suites', routerLink: '/admin/suites' }),
        new SidenavLink({ title: 'Technology', iconClass: 'fa fa-laptop', description: 'Edit technology', routerLink: '/admin/technology' }),
        new SidenavLink({ title: 'Services', iconClass: 'fa fa-user-md', description: 'Edit services', routerLink: '/admin/services' }),
        new SidenavLink({ title: '3rd Party Technology', description: 'Edit 3rd party technology', iconClass: 'fa fa-handshake-o', routerLink: '/admin/partners' }),
        new SidenavLink({ title: 'Sources', description: 'Edit sources', iconClass: 'hc-icons hci-binding', routerLink: '/admin/sources' }),
        new SidenavLink({ title: 'Change Log', iconClass: 'fa fa-history', description: 'View changes to product catalog items', routerLink: '/admin/change-log' }),
        new SidenavLink({ title: 'Product Lines', description: 'Edit product lines', iconClass: 'fa fa-sitemap', routerLink: '/admin/product-lines' }),
        new SidenavLink({ title: 'Statuses', description: 'Edit statuses', iconClass: 'fa fa-check-circle', routerLink: '/admin/statuses' }),
        new SidenavLink({ title: 'SLAs', description: 'Edit SLAs', iconClass: 'fa fa-file-text', routerLink: '/admin/slas' }),
        new SidenavLink({ title: 'Terminology', description: 'Edit terminology', iconClass: 'fa fa-clipboard', routerLink: '/admin/terminology' }),
        new SidenavLink({ title: 'Downloads', description: 'Edit downloads', iconClass: 'fa fa-download', routerLink: '/admin/downloads' }),
        new SidenavLink({ title: 'API Keys', description: 'View all API keys', iconClass: 'fa fa-key', routerLink: '/admin/keys' }),
        new SidenavLink({ title: 'Feedback', description: 'View feedback form responses', iconClass: 'fa fa-comments', routerLink: '/admin/feedback' })
    ];

    constructor(private router: Router, public oktaService: OktaService) {
        this.router.events.pipe(takeUntil(this.unsubscribe)).subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.isEditing = event.url.includes('/editor');
            }
        });
        this.oktaService.superAdminUpdated.pipe(takeUntil(this.unsubscribe)).subscribe(adminVal => {
            if ( adminVal ) {
                let tabTitles: string[] = [];

                this.tabs.forEach((tab)=>{
                    tabTitles.push(tab.title);
                });

                if (adminVal && !tabTitles.includes('Users')) {
                    this.tabs.push(
                        new SidenavLink({
                            title: 'Users',
                            iconClass: 'fa fa-users',
                            description: 'Edit users',
                            routerLink: '/admin/users'
                        })
                    );
                }
            }
        });
    }

    ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
